import { render } from "./service_people.vue?vue&type=template&id=3e776afd&scoped=true"
import script from "./service_people.vue?vue&type=script&lang=js"
export * from "./service_people.vue?vue&type=script&lang=js"

import "./service_people.vue?vue&type=style&index=0&id=3e776afd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e776afd"]])

export default __exports__